import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import * as Sentry from '@sentry/react';
import { createSession, getPreLoadedState, getSessionFromCookie } from '~/services/StateService';
import { IPage, ISettings } from './sharedInterfaces/SharedInterfaces';
import rootReducer from './reducers/rootReducer';

const sentryReduxEnhancer = Sentry.createReduxEnhancer();

const configureStore = (pages: IPage[], settings: ISettings) => {
  const sessionId = getSessionFromCookie() || createSession();
  const state = getPreLoadedState(pages, settings, sessionId);
  Sentry.setTag('widgetSessionId', sessionId);
  Sentry.setTag('market', settings.market);
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const store = createStore(
    rootReducer,
    state,
    composeEnhancers(applyMiddleware(thunk), sentryReduxEnhancer)
  );

  return store;
};

export default configureStore;
